export default __webpack_public_path__ + "static/media/meta-mask.103323ff.svg";